module.exports = __webpack_public_path__ + "img/eu.467e8f13.png";